import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ClientService } from '@shared/services/client.service';
@Component({
  selector: 'db-answer-set-header-details',
  templateUrl: './answer-set-header-details.component.html',
  styleUrls: ['./answer-set-header-details.component.scss']
})
export class AnswerSetHeaderDetailsComponent implements OnInit {
  @Input() data: any;
  folderUrl: SafeUrl;

  constructor(private _clientService: ClientService, private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.createClientFolder();
  }

  createClientFolder() {
      this._clientService.createClientFolder(this.data.client.clientId).subscribe(
        ((response: string) => {
          const cleanUrl = response.replace(/^"+|"+$/g, '');
          this.folderUrl = this.sanitizer.bypassSecurityTrustUrl(cleanUrl);
        })
      );
  }
}
